import { createBrowserRouter } from 'react-router-dom';
import LaunchContainer from './pages/launch';
import ProxyContainer from './pages/proxy';
import ErrorComponent from './components/error/error';

export const AppRouter = createBrowserRouter([
    {
        path: '/',
        element: <ErrorComponent />,
    },
    {
        path: ':customer',
        element: <ProxyContainer />,
        errorElement: <ErrorComponent/>
    },
    {
        path: ':customer/:appName',
        element: <LaunchContainer />,
        errorElement: <ErrorComponent/>
    }
]);
